module.exports = __webpack_public_path__ + "static/media/back.45b7ee82.svg";